import React, { useReducer, useState } from 'react';
import './App.css';

let randomColor = Math.floor(Math.random() * 16777215).toString(16);

const formReducer = (state, event) => {
  return {
    ...state,
    [event.name]: event.value
  }
 }

function shiftRow(arr, row) {
  arr[row].push(arr[row].shift());
  return arr;
}

function transform(word){
  word = word.toString();
 // console.log(word)
  var word2 = word.split('');
 // console.log(word2);
  word2 = word2.concat('$');
 // console.log(word2);
  let mat = Array(word2.length).fill(word2)
 // console.log(mat)
  let matnew = JSON.parse(JSON.stringify(mat));
  
  for (let i = 1; i <= (word2.length - 1); i++){
  //  console.log(i)
    for(let j=1; j <= i; j++) {
  //    console.log(j)
      shiftRow(matnew,i);
   //   console.log(matnew)
    }
  }
  var matnew2 = JSON.parse(JSON.stringify(matnew));
  for (let i = (word2.length - 1); i >= 0; --i){
//    console.log(i)
    var col = matnew2.map(function(value,index) { return value[i]; });
//  console.log(col);
    var len = col.length;
    var indices = new Array(len);
    for (var j = 0; j < len; ++j) indices[j] = j;
    indices.sort(function (a, b) { return col[a] < col[b] ? -1 : col[a] > col[b] ? 1 : 0; });
    let mattemp = [matnew2[indices[0]]];
    for (let j = 1; j <= (word2.length - 1); j++){
    	mattemp.push(matnew2[indices[j]]);
    }
    
  var matnew2 = JSON.parse(JSON.stringify(mattemp));
  }
  let newword = matnew2.map(function(value,index) { return value[word2.length - 1]; });
  return(newword.join(''))
 }

 function invtransform(bwword){

	// create array with word
	const bwarr = bwword.split("");
//  console.log(bwarr)
  let bwarrtemp = bwword.split("");

	// create 2d array
  const bwarNew = [];
	while(bwarrtemp.length) bwarNew.push(bwarrtemp.splice(0,1));
//  console.log(bwarNew)
  
  // sort row by first column
  var col = bwarr.map(function(value,index) { return value[0]; });
//  console.log(col)
  var len = bwarr.length;
//  console.log(len);
  var indices = new Array(len);
  for (var j = 0; j < len; ++j) indices[j] = j;
  indices.sort(function (a, b) { return col[a] < col[b] ? -1 : col[a] > col[b] ? 1 : 0; });
//  console.log(indices);
	let bwarNewtemp = [bwarNew[indices[0]]];
  for (let j = 1; j <= (len - 1); j++){
    	bwarNewtemp.push(bwarNew[indices[j]]);
   }
//  console.log(bwarNewtemp)
 
  
 	for (let i = 1; i < len; ++i){
    // bind word
  	for (let k = 0; k < len; ++k){
    	bwarNewtemp[k][0] = bwarr[k].concat('', bwarNewtemp[k][0])
    }
  //  console.log(bwarNewtemp)
    // sort 
    let bwarNewtemp2 = [bwarNewtemp[indices[0]]];
  //  console.log(bwarNewtemp2)
  	for (let j = 1; j <= (len - 1); j++){
    	bwarNewtemp2.push(bwarNewtemp[indices[j]]);
  //    console.log(bwarNewtemp2)
   }
   bwarNewtemp = bwarNewtemp2
  }
//  console.log(bwarNewtemp)
  
  // remove last column
  let last = [bwarNewtemp[0][0].slice(-1)];
  for (let m = 1; m < len; m++){
  	let temp = [bwarNewtemp[m][0].slice(-1)];
  	last = last.concat(temp)
  }
//  console.log(last)
  
  // find index of bwarNewtemp containing original word
  let origRow = last.indexOf('$')
//  console.log(origRow)
  
  // extract row with original word
  let origWord = bwarNewtemp[origRow][0]
  origWord = origWord.substring(0, origWord.length - 1);
  
  return(origWord)
}


function bw(word){
  let wordlower = word.toLowerCase()
  if (wordlower.includes("$")) {
    return(invtransform(wordlower));
  } else {
    return(transform(wordlower));
  }
}



function App() {
  const [formData, setFormData] = useReducer(formReducer, {});
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = event => {
    event.preventDefault();
    setSubmitting(true);

//    setTimeout(() => {
//      setSubmitting(false);
//    }, 2000)
  }

  const handleChange = event => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  }

  return (
    <div className="wrapper">
      <div
        className="child-container"
        style={{ backgroundColor: "#" + `${randomColor}` }}
      >
      <div
        className="child-container"
        style={{ padding: '0px 10px 10px 10px' }}
      > 
      <h2>⚡ BW TRANSFORMER ⚡</h2>
      <form onSubmit={handleSubmit}>
      <fieldset>
         <label>
           <p>enter word or transformation</p>
           <input name="word" onChange={handleChange}/>
         </label>
       </fieldset>
       <button type="submit">transform!</button>
      </form>
      <div
        className="child-container"
        style={{ padding: '0px 10px 10px 10px' }}
      ></div>
      {submitting &&
       <div>
        <ul>
            {Object.entries(formData).map(([name, value]) => (
             bw(value)
           ))}
        </ul>
       </div>
     }
      </div>
      </div>
    </div>
  )
}

export default App;